import { createContext } from 'react'
import type { LogsExplorerState } from '@/components/shared/logs-explorer/types'

export const LogsExplorerContext = createContext<LogsExplorerState | null>(null)
